import React from 'react'

import { ActionButton, RfShell } from '../components/RfShell'
import { RfStatusBanner } from '../components/RfStatusBanner'
import { receivingContext, ReceivingFlowController } from '../flow'
import { planDescription } from '../labels'
import { AsnSummaryCard, AsnSummaryDetails, AsnSummaryHeader, LabelPlanList, TaskHeader } from '../styles'

interface LabelPlanScreenProps {
  controller: ReceivingFlowController
  embedded?: boolean
  onExit: () => void
}

export const LabelPlanScreen = ({ controller, embedded = false, onExit }: LabelPlanScreenProps) => {
  const { state, dispatch } = controller
  const plan = state.preprocess?.labelPlan
  if (!plan) return null

  return (
    <RfShell
      title="Receiving"
      phase="Labels"
      embedded={embedded}
      contextSummary={receivingContext(state)}
      onBack={() => dispatch({ type: 'back' })}
      moreActions={[{ label: 'Exit receiving', onSelect: onExit, danger: true }]}
      actions={
        <ActionButton type="button" onClick={() => dispatch({ type: 'reserve-label-identities' })}>
          Prepare labels
        </ActionButton>
      }
    >
      <TaskHeader>
        <h1>Review label plan</h1>
      </TaskHeader>
      {state.status ? <RfStatusBanner tone={state.status.tone}>{state.status.message}</RfStatusBanner> : null}
      <AsnSummaryCard>
        <AsnSummaryHeader>
          <strong>{plan.palletized ? 'Palletized' : 'Cartons'}</strong>
          <span>Quantity to receive: {plan.remainingUnits.toLocaleString('en-US')} eaches</span>
        </AsnSummaryHeader>
        <AsnSummaryDetails>
          <dt>Labels</dt>
          <dd>{plan.totalLabels}</dd>
          <dt>Loose eaches</dt>
          <dd>{plan.remainderEaches}</dd>
        </AsnSummaryDetails>
      </AsnSummaryCard>
      <LabelPlanList aria-label="Planned labels">
        {plan.items.map((item) => (
          <li key={item.level}>
            <strong>
              {item.count} × {planDescription(item).type}
            </strong>
            <span>
              {item.unitsPerContainer} eaches
              {planDescription(item).fullness
                ? ` · ${planDescription(item).fullness === 'Full pallet' ? 'Full' : 'Partial'}`
                : ''}
            </span>
          </li>
        ))}
        {plan.items.length === 0 ? <li>No new labels required.</li> : null}
      </LabelPlanList>
    </RfShell>
  )
}
